import { getI18n as e } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var t = {
	messages: {
		en: {
			apiUserApi: {
				createAlreadyExists: "Can't create API user because another user with this application name already exists",
				updateAlreadyExists: "Can't update API user because another user with this application name already exists",
				created: "API user created",
				updated: "API user updated",
				notFound: "API user not found",
				requiredFields: "You can't save the API user because mandatory information is missing"
			},
			apiUserList: {
				newButton: "New API user",
				name: "Search by application name",
				applicationName: "Application name",
				teamName: "Team name",
				email: "Email",
				isEnabled: "Enabled",
				headerCreatedAt: "Created at",
				headerChangedAt: "Changed at",
				dpEdit: "Edit",
				dpView: "View",
				messageDeleted: "API user deleted",
				errorOnDeleting: "Error on deleting",
				createApiUser: "Create API user",
				title: "API Manager"
			},
			apiUser: {
				apiUserLabel: "API Manager",
				backButton: "Back to API Manager list",
				newApiUser: "New API user",
				messageDeleteApiUser: "Delete API user",
				messageDeleteApiUserTitle: "Are you sure you want to delete this API user?",
				deleteApiUser: "Delete",
				messageDeleted: "API user deleted",
				messageActive: "API user active",
				messageBlocked: "API user blocked",
				errorOnDeleting: "There was an error deleting the API user",
				errorFailedOperation: "Operation failed",
				errorFailedLoadedApiUserWithId: "There was an error getting the API user"
			},
			apiUserEdit: {
				applicationName: "Application name",
				teamName: "Team name",
				email: "Email",
				isEnabled: "Enabled",
				secret: "Secret",
				moduleAccess: "Permissions",
				read: "Read",
				write: "Write",
				delete: "Delete",
				test: "Test",
				testTooltip: "Grants access to experimental endpoints and to endpoints reserved for QA testing.",
				scopeName: "Module",
				searchScopes: "Search module...",
				readAll: "Read all",
				writeAll: "Write all",
				deleteAll: "Delete all",
				testAll: "Test all",
				clearAll: "Clear",
				backButton: "Back to API Manager list",
				editApiUser: "Edit API user",
				messageSaved: "API user saved",
				applicationNameKebabCase: "Application name must be in kebab-case (e.g. my-app)"
			},
			apiUserCopySecret: {
				dialogTitle: "Copy Secret",
				dialogMessage: "The secret \"{secret}\" will not be shown again for security reasons. Click “Copy secret” to copy it to your clipboard and store it safely.",
				copyButton: "Copy secret",
				successMessage: "Secret copied to clipboard",
				errorMessage: "Failed to copy secret to clipboard"
			}
		},
		de: {
			apiUserApi: {
				createAlreadyExists: "API-Nutzer kann nicht erstellt werden, da bereits ein Nutzer mit diesem Applikationsnamen existiert",
				updateAlreadyExists: "API-Nutzer kann nicht aktualisiert werden, da bereits ein Nutzer mit diesem Applikationsnamen existiert",
				created: "API-Nutzer erstellt",
				updated: "API-Nutzer aktualisiert",
				notFound: "API-Nutzer nicht gefunden",
				requiredFields: "Sie können den API-Nutzer nicht speichern, da obligatorische Informationen fehlen"
			},
			apiUserList: {
				newButton: "Neuer API-Nutzer",
				name: "Suche nach Applikationsnamen",
				applicationName: "Applikationsname",
				teamName: "Teamname",
				email: "E-Mail",
				isEnabled: "Aktiviert",
				headerCreatedAt: "Erstellt am",
				headerChangedAt: "Geändert am",
				dpEdit: "Bearbeiten",
				dpView: "Anzeigen",
				messageDeleted: "API-Nutzer gelöscht",
				errorOnDeleting: "Fehler beim Löschen",
				createApiUser: "API-Nutzer erstellen",
				title: "API-Manager"
			},
			apiUser: {
				apiUserLabel: "API-Manager",
				backButton: "Zurück zur API-Manager-Liste",
				newApiUser: "Neuer API-Nutzer",
				messageDeleteApiUser: "API-Nutzer löschen",
				messageDeleteApiUserTitle: "Sind Sie sicher, dass Sie diesen API-Nutzer löschen möchten?",
				deleteApiUser: "Löschen",
				messageDeleted: "API-Nutzer gelöscht",
				messageActive: "API-Nutzer aktiv",
				messageBlocked: "API-Nutzer blockiert",
				errorOnDeleting: "Es gab einen Fehler beim Löschen des API-Nutzers",
				errorFailedOperation: "Vorgang fehlgeschlagen",
				errorFailedLoadedApiUserWithId: "Es gab einen Fehler beim Abrufen des API-Nutzers"
			},
			apiUserEdit: {
				applicationName: "Applikationsname",
				teamName: "Teamname",
				email: "E-Mail",
				isEnabled: "Aktiviert",
				secret: "Passwort (Secret)",
				moduleAccess: "Berechtigungen",
				read: "Lesen",
				write: "Schreiben",
				delete: "Löschen",
				test: "Test",
				testTooltip: "Gewährt Zugriff auf experimentelle Endpunkte und auf Endpunkte, die für QA-Tests vorgesehen sind.",
				scopeName: "Modul",
				searchScopes: "Modul suchen...",
				readAll: "Alle Lesen",
				writeAll: "Alle Schreiben",
				deleteAll: "Alle Löschen",
				testAll: "Alle Testen",
				clearAll: "Alle Leeren",
				backButton: "Zurück zur API-Manager-Liste",
				editApiUser: "API-Nutzer bearbeiten",
				messageSaved: "API-Nutzer gespeichert",
				applicationNameKebabCase: "Der Applikationsname muss im Kebab-Case-Format angegeben werden (z. B. my-app)"
			},
			apiUserCopySecret: {
				dialogTitle: "Passwort (Secret) kopieren",
				dialogMessage: "Das Secret \"{secret}\" wird aus Sicherheitsgründen nicht erneut angezeigt. Klicke auf „Secret kopieren“, um es in die Zwischenablage zu kopieren und sicher zu speichern.",
				copyButton: "Passwort kopieren",
				successMessage: "Passwort in die Zwischenablage kopiert",
				errorMessage: "Passwort konnte nicht in die Zwischenablage kopiert werden"
			}
		}
	},
	routes: [{
		path: "/api-user",
		children: [
			{
				path: "",
				name: "api_user_list",
				component: () => import("./api-user-list.view-Bf9O-aGJ.js"),
				meta: { requiredRight: "api-users:navigate" }
			},
			{
				path: "new",
				name: "api_user_new",
				component: () => import("./api-user-edit.view-Divi6lRw.js"),
				props: () => ({
					title: e().t("apiUser.newApiUser"),
					backRoute: "/api-user"
				}),
				meta: { requiredRight: ["api-users:navigate"] }
			},
			{
				path: ":id",
				name: "api_user_detail",
				component: () => import("./api-user-edit.view-Divi6lRw.js"),
				props: (t) => ({
					title: e().t("apiUserEdit.editApiUser"),
					id: t.params.id,
					backRoute: "/api-user"
				}),
				meta: { requiredRight: ["api-users:navigate"] }
			}
		]
	}]
};
//#endregion
export { t as apiUserModule };

//# sourceMappingURL=index.es.js.map